import { defaultAccountingConcept,defaultSelectedAccountingConceptTransaction } from "./state";


export function setPerPage(state, perPage) {
    state.params.page = 1;
    state.params.perPage = perPage;
}

export function setPage(state, page) {
    state.params.page = page;
}
export function setFilter(state, filter) {
    state.params.filter = filter;
}

export function clearSelectedModel(state) {
    state.selectedAccountingConcept = defaultAccountingConcept();
}
export function clearSelectedAccountingConceptTransaction(state) {
    state.selectedAccountingConceptTransaction = defaultSelectedAccountingConceptTransaction();
}

export function setActionFormTransactions(state, action) {
    state.actionFormTransactions = action;
}
export function setAction (state, action) {
    state.action = action;
}
export function setdisabledInputs(state, disabled) {
    state.disabledInputs = disabled;
}

export function setAccountingConcepts(state, data){
    state.accounting_concepts = data.data.data;
}

export function setSelectedAccountingConcept(state, data){
   state.selectedAccountingConcept = data;
}
export function setAccountingConceptTransaction(state, data){
   state.selectedAccountingConceptTransaction = data;
}
export function setAccounts(state, data){
   state.accounts = data;
}
export function setFile(state, data){
   state.file = data;
}

/**
 * Establecer un valor para la variable parameters.
 */
export function setParameters(state, parameters) {
    state.parameters = parameters;
}




// WEBPACK FOOTER //
// ./src/modules/accounting_concept/mutations.js